/* tslint:disable max-line-length */

export const messages: any = {
  components_plugin: {
    advice: {
      title: 'Conseil',
    },
    common: {
      close: 'Fermer',
      password: 'Mot de passe',
      email: 'E-mail',
      sign_in: 'Se connecter',
      welcome_to_login: 'Connexion à votre espace',
      hide_password: 'Masquer le mot de passe',
      show_password: 'Voir le mot de passe',
      retry: 'Réessayer',
    },
    payment: {
      cancelled: 'Payment annulé.',
      refused: 'Payment refusé.',
    },
    home_odd_jobs: {
      headline: `Dépannage ou petits travaux, `,
      headline2: `nous avons la solution !`,
      button_text: `C'est parti !`,
      phone_block: `Ou par téléphone au <a class="caption tertiary--text" style="text-decoration: none;" href="tel:{supportPhoneNumber}"><strong>{supportPhoneNumber}</strong></a>`,
      phone_block_no_link: `Ou contactez-nous au <strong>{supportPhoneNumber}</strong>`,
      phone_block_no_link_extra: `<span>Service gratuit + coût de l’appel</span>`,
      order_phone: `Commandez au <strong>{supportPhoneNumber}</strong>`,
      domain_selector_error: 'Veuillez renseigner votre besoin',
      reinsurance: {
        content: `Nous choisissons pour vous l’expert qualifié pour répondre à votre demande de dépannage ou de petits travaux chez vous.`,
        headline: `Le groupe HomeServe réalise 1 intervention toutes les 3 minutes partout en France <sup>(1)</sup> parmi les 4000 professionnels de son réseau.`,
      },
    },
    home_conversion: {
      headline: `Pour tous vos dépannages et petits travaux, <span class="display-3">Réservez en ligne ou au téléphone</span>`,
      order_by_internet: {
        button_text: `Je réserve par internet`,
      },
      order_by_phone: {
        headline: `Ou par téléphone`,
        noweb: `Par téléphone`,
        button_text: `01 70 96 50 63`,
      },
    },
    product_list: {
      starting_from: 'À partir de',
    },
    auth0: {
      access_denied: 'Mauvais email ou mot de passe.',
      too_many_attempts:
        'Votre compte a été bloqué après plusieurs tentatives de connexion consécutives. Nous vous avons envoyé un email avec les instructions pour le débloquer.',
    },
    errors: {
      unexpected: 'Une erreur inattendue s’est produite.',
      fetchingPaymentMethodsError: 'Une erreur est survenue lors de la récupération des moyens de paiements.',
    },
    new_invoice: {
      title: `Vous bénéficiez d'une remise`,
      subtitle: 'Veuillez payer votre intervention',
      price: 'Prix',
      voucher: 'Remise {code}',
      discount: 'Remise',
      price_to_pay: 'Prix à payer',
      invoice_updated: 'Votre facture a été actualisée',
      cta_download_invoice: 'Télécharger ma facture',
      invoice: 'Facture',
      error_download_invoice: 'Une erreur est survenue lors du téléchargement',
    },
    rating: {
      baseline: `Plus de <strong>190000 interventions</strong> en 2019. Nous choisissons pour vous, parmi plus de 4000 professionnels, l'expert qualifié <strong>pour répondre à votre besoin !</strong>`,
      customer_service_of_the_year: `Le groupe HomeServe a été élu service client de l'année <sup>(1)</sup>`,
      satisfaction_rate: `97 % de taux de satisfaction <sup>(1)</sup>`,
      title: `Le groupe HomeServe, leader des services pour les réparations et les travaux de la maison`,
    },
    voucher_input: {
      i_have_a_discount_code: `Saisir un code promo`,
      fill_your_code: `Saisissez votre code ci-dessous :`,
      validate: `Je valide`,
      button_title: 'Supprimer le code promo',
      please_enter_a_valid_promo_code: `Veuillez saisir un code promo valide`,
      this_discount_code_is_not_valid: `Désolé, ce code promo n'est pas valide`,
      this_discount_code_is_expired: `Désolé, ce code promo est expiré`,
      this_discount_code_does_not_reach_minimum_amount: `Désolé, ce code promo n'atteint pas le montant minimum de {amount}`,
      discount_code: 'Code promo',
    },
    diagnosis: {
      postcode: `Votre code postal`,
      postcode_hint: `Afin de nous assurer que nous avons bien un expert près de chez vous`,
      postcode_question: `Votre code postal ?`,
      problem_question: `Quel est votre problème ?`,
      error_invalid_postcode: `Veuillez renseigner un code postal valide`,
      error_not_covered_postcode: `Désolé, nous n'intervenons pas dans votre commune`,
      previous_step_button: `étape précédente`,
      not_sure_problem: `Vous n'êtes pas sûr du problème ?`,
      not_sure_problem_text: `Nous vous aidons à diagnostiquer votre problème :`,
      not_sure_problem_contact: `Contactez-nous au`,
      gaz: {
        title: 'Dépannage gaz : réalisons ensemble le diagnostic !',
        content: `<p>Un problème avec vos canalisations gaz ? Vous sentez une odeur de gaz chez vous ?
        Simple et rapide, prévoyez une intervention avec nos professionnels du gaz.</p>
        Notre réseau de 4000 professionnels agréés HomeServe, nous permet d’intervenir dans
        toute la France. En cas de <a href="/produit/recherche-fuite-gaz">problème sur vos canalisations de gaz</a> dans votre habitation,
        nous nous chargeons de choisir le professionnel du gaz le plus adapté, avec les meilleures
        compétences pour résoudre votre problème rapidement.`,
        sub_title: 'Besoin d’aide pour identifier votre problème de gaz ?',
        sub_content: `<p>Que vous ayez besoin de <a href="/produit/remplacement-flexible-gaz-inox">remplacer un flexible de gaz</a> ou encore réparer un robinet d’arrêt
        sur votre installation gaz, nos équipes vous accompagnent !</p>
        <p>Nous vous aidons à diagnostiquer votre problème de gaz :</p>
        <p>Contactez-nous au {supportPhoneNumber} (Service gratuit + coût de l&#39;appel).</p>
        <p>Une fois votre commande passée, notre professionnel vous contacte et fixe un rendez-vous
        en fonction de vos disponibilités.</p>`,
      },
      nuisibles: {
        title: 'Solutions anti-nuisibles : faites confiance à nos experts',
      },
      electricite: {
        title: 'Dépannage et réparation électrique : diagnostiquons votre besoin !',
        content: `<p>Vous avez une <a href="/produit/recherche-reparation-panne-electrique">panne électrique</a> chez vous ? Votre chauffage ne fonctionne plus ? En
          quelques clics, votre problème d‘électricité est résolu grâce à MesBonsPros.</p>
          <p>Notre réseau de professionnels certifiés est présent dans toute la France afin d’intervenir
          rapidement à votre domicile. En cas de problème électrique urgent, nos équipes se
          mobilisent pour vous mettre en contact avec l’un de nos électriciens agréés. Ce
          professionnel intervient dans les meilleurs délais pour un dépannage électrique en toute
          sécurité.</p>`,
        sub_title: 'Besoin d’aide pour identifier votre problème d’électricité ?',
        sub_content: `<p>Vous avez besoin de réaliser un diagnostic électrique ? Nos électriciens certifiés
          interviennent à domicile afin d’<a href="/produit/diagnostic-electricite-devis">examiner l’état de votre installation électrique</a>.</p>
          <p>Ce type de diagnostic est obligatoire si vous souhaitez par exemple vendre votre bien. Cela
          permet également à nos électriciens d’étudier votre problème en profondeur et vous
          proposer un devis détaillé correspondant à vos besoins.</p>
          <p>Contactez-nous au 01 70 82 17 82 (Service gratuit + coût de l&#39;appel).
          Une fois votre commande passée, notre professionnel vous contacte dans les plus brefs
          délais pour convenir d’un rendez-vous.</p>`,
      },
      plomberie: {
        title: 'Réparation et dépannage plomberie : confiez le diagnostic à des professionnels !',
        content: `<p>Vous êtes confrontés à un problème de plomberie chez vous ? HomeServe vous assure un
        <strong>dépannage plomberie rapide.</strong></p><p>Il n’est jamais simple de faire face à un sinistre plomberie. Ce genre de situation nécessite
        une intervention rapide. Par internet ou par téléphone, nous sommes joignables du lundi au
        vendredi de 07h00 à 21h00. Nous sélectionnons un plombier agréé proche de chez vous afin
        de vous dépanner en urgence à votre domicile.</p>`,
        sub_title: 'Besoin d’aide pour identifier votre problème de plomberie ?',
        sub_content: `<p>Impossible de comprendre d’où vient le problème ? Vous souhaitez en savoir plus sur l’état
        général de votre maison ou appartement ?</p>
        <p>Nous réalisons des diagnostics plomberie gratuit pour vous aider à mieux comprendre l’état
        de vos installations. Nos professionnels sauront analyser la situation : <a href="/produit/recherche-fuite-canalisation-exterieure">fuite extérieure</a>, plus
        d’eau chaude, surconsommation eau etc. et déterminer les solutions adaptées à votre
        problématique.</p>
        <p>Contactez-nous au 01 70 82 17 82 (Service gratuit + coût de l&#39;appel)<br/>
        Une fois votre commande passée, notre plombier vous contacte avant son passage pour
        affiner le diagnostic.</p>`,
      },
      serrurerie: {
        title: 'Dépannage serrurerie : diagnostiquons ensemble votre besoin !',
        content: `<p>Vous avez claqué votre porte en laissant vos clés à l’intérieur ? Votre porte est bloquée,
        impossible de comprendre d’où vient le problème ? MesBonsPros vous aide à
        régler rapidement ce problème de <a href="/produit/ouverture-porte-claquee-non-verrouillee">porte claquée</a>, bloquée ou fermée à clé.</p>
        <p>Pour éviter les arnaques et les mauvaises surprises faite appel à un serrurier professionnel
        agrée par HomeServe. Notre réseau de professionnels est présent dans toute la France,
        près de chez vous pour un dépannage rapide à votre domicile.</p>`,
        sub_title: 'Besoin d’aide pour identifier le problème avec votre serrure ?',
        sub_content: `<p>Nous vous aidons à diagnostiquer votre problème de serrurerie :</p>
        <p>Contactez-nous au 01 70 82 17 82 (Service gratuit + coût de l&#39;appel)</p>
        <p>Une fois votre commande passée, notre professionnel vous contacte avant son passage
        pour affiner le diagnostic.</p>`,
      },
      electromenager: {
        title: 'Faites réparer votre électroménager par des professionnels !',
        content: `<p>Les appareils électroménagers sont très utiles au quotidien mais il peut arriver qu’ils tombent en panne.
        Un lave-vaisselle qui fuit, un frigo qui ne fonctionne plus… cela n’arrive jamais au bon moment.</p>
        <p>Pour tous ces petits tracas du quotidien HomeServe a la solution ! Nos experts en électroménager sont disponibles 7j/7 pour un dépannage à domicile dans les meilleurs délais.</p>`,
        sub_title: 'Des dépannages en électroménager réalisés dans toute la France',
        sub_content: `<p>Bien souvent, lorsqu’un appareil électroménager tombe en panne, le premier réflexe est de le jeter pour en acheter un nouveau. Mais avez-vous pensé à la réparation ?</p>
        <p>De nombreuses pannes sont en effet réparables et cela à de nombreux avantages aussi bien en terme économique, qu’écologique !
        En cas de panne, contactez-nous au 01 70 82 17 82 (Service gratuit + coût de l'appel) et nous réaliserons ensemble un diagnostic de votre appareil électroménager.</p>
        <p>Une fois cet appel terminé, vous saurez si votre appareil est réparable et combien cela vous coûtera.</p>`,
      },
      diagnosis_next_step: `Une fois votre commande passée, notre professionnel vous contacte avant son passage pour <strong>affiner le diagnostic.</strong>`,
      google_tag_manager_category_domain: 'Diagnostic {domain}',
      google_tag_manager_insider_action: 'Initié',
      google_tag_manager_uncovered_action: 'Non couvert',
      google_tag_manager_no_trader_action: 'Aucun trader disponible',
      page_name: 'Page diagnostic',
      title: `<strong>Besoin d'un dépannage</strong>&nbsp;en plomberie, électricité ou gaz&nbsp;?`,
      domain_choice: `Quel est votre besoin ?`,
      error_domain_choice: `Veuillez renseigner votre problème`,
      advantage_1: `Prix <b>communiqué à l'avance</b>`,
      advantage_2: `Réparations <b>100% confiance</b>`,
      advantage_3: `Paiement <b>3x ou 4x sans frais</b>`,
      disclaimer: `* jusqu'à 2 heures avant l'arrivée du pro`,
      submit: `Être dépanné`,
    },
    order_confirmation: {
      confirm_button_label: 'Valider ma commande',
      voucher_invalid: 'Désolé, ce coupon de réduction est invalide. Vous pouvez valider votre commande sans le coupon',
      please_fill_your_payment_informations: `Veuillez saisir vos informations de paiement ci-dessous.`,
      cancel_without_fees: `Vous aurez à tout moment la possibilité d'annuler l'intervention sans frais jusqu'à 2 heures avant le début de l'intervention depuis votre espace de suivi de commande.`,
      you_will_only_be_charged_after_the_execution: `Vous ne serez débité qu'après l'exécution de votre intervention.`,
      late_checkout_explication: `Une fois l'intervention réalisée vous devrez saisir vos informations de carte bancaire directement sur le site MesBonsPros`,
      title: `Nous intervenons d’abord, vous payez ensuite`,
      title_no_imprint: `Réservez votre dépannage`,
      total_price: `Total à payer à la fin de l'intervention :`,
      debit_card_informations_error: 'Les informations de carte bancaire ne semblent pas valides.',
      renounce_retractation: `Je reconnais renoncer à mon droit de rétractation si le Pro intervient, à ma demande, avant la fin du délai légal de rétractation de 14 jours. <i style="color:#258386;">(Requis)<i/>`,
      accept_terms_1: ` Je reconnais avoir lu et accepté le devis provisoire, les `,
      sales_terms: 'conditions générales de vente',
      accept_terms_2: ` ainsi que les `,
      job_conditions: `conditions particulières de la commande`,
      accept_terms_3: `<i style="color:#258386;">(Requis)<i/>`,
      accept_terms_4: `J’ai bien noté que ma réservation implique une obligation de paiement à la fin de l’intervention.`,
      checkbox_missing: `Veuillez cocher toutes les cases obligatoires`,
      payment_option_website: `Empreinte CB et validation sur place`,
      payment_option_onsite: `Paiement après intervention`,
      select_payment: `Sélectionnez votre mode de paiement :`,
      select_payment_error: `Veuillez sélectionner un mode de paiement`,
      card_invalid: `Vos données de carte bancaire ne sont pas valides, veuillez vérifier les informations renseignées`,
      place_order: `Valider ma commande`,
      payment_error: `Une erreur est survenue, merci de réessayer plus tard`,
      confirmation_email: `Nous vous enverrons une confirmation de commande instantanée à l'adresse <strong>{email}</strong>`,
      confirmation_sms: `Vous recevrez également un SMS de confirmation`,
      intervention_date_confirm: `Confirmation de la date d'intervention`,
      cgu_confirm: `Conditions générales de vente`,
      bank_redirect_title: 'Redirection vers votre banque',
      bank_redirect_content:
        'Veuillez patienter, nous allons vous rediriger vers le site de votre banque. <br>Vous pouvez cliquer sur le lien suivant si la redirection ne se fait pas',
      continue: 'Continuer',
      info_card:
        "<b>Votre carte ne sera débitée qu'une fois l'intervention réalisée.</b><br>Nous avons seulement besoin de votre pré-autorisation bancaire.",
      info_alma:
        'Vous souhaitez bénéficier du paiement en 3x ou 4x sans frais ? Rendez-vous, à l’issue de l’intervention, dans votre espace de suivi afin d’en faire la demande.',
      info_scheme:
        'Votre carte bancaire sera débitée du montant de votre facture, dans les 7 jours suivants l’intervention.',
      more_details:
        'Ces informations sont nécessaires à HomeServe et au prestataire de paiement électronique pour le paiement de votre commande. Pour plus d’informations sur vos données et sur vos droits, consultez notre <a href="{url}" title="politique de données personnelles">politique de données personnelles</a>.',
      more_details_no_imprint:
        "Une fois l'intervention réalisée vous devrez saisir vos informations de carte bancaire directement sur le site MesBonsPros *",
      how_to_pay: 'Saisissez vos coordonnées bancaires :',
    },
    fourOfour: {
      page_name: `Désolé cette page n'existe pas`,
      title: `oh non ! ERREUR 404<br/>la page demandée a disparu`,
      desc: `Un des tuyaux du serveur est bouché ou alors nous avons un court-jus !<br/>Un expert est déjà au travail pour rétablir tout ça :)<br/>En attendant nous vous invitons à poursuivre la navigation sur notre site.`,
      cta_back_home: `Retour à l'accueil`,
    },
    authFailed: {
      title: `Une erreur technique nous empêche d'afficher cette page`,
      desc: `Veuillez réessayer plus tard`,
    },
    domains: {
      O: `plomberie`,
      E: `électricité`,
      G: `gaz`,
      C: `climatisation`,
      H: `chauffage`,
      slugs: {
        O: `plomberie`,
        E: `electricite`,
        G: `gaz`,
        C: `climatisation`,
        H: `chauffage`,
      },
    },
    schedule_slots: {
      no_preference: 'Pas de préférence',
      morning: `matin`,
      am: `matin`,
      afternoon: `après-midi`,
      pm: `après-midi`,
      evening: `soirée`,
    },
    navbar: {
      order_tracking_button: `Suivre votre commande`,
      homeserve_link: 'HomeServe.fr',
      who_we_are_link: `Qui sommes-nous ?`,
      help_link: `Aide`,
      pro_link: `Espace Pro`,
      phone_number: `{supportPhoneNumber}`,
      phone_number_link: `tel:{supportPhoneNumber}`,
      phone_fees: `Service gratuit + coût de l'appel`,
    },
    SEOZone: {
      diagnosis: 'Diagnostic',
      repair: 'Dépannage',
    },
    footer: {
      hotline_title: `Vous êtes un <strong>particulier</strong>`,
      hotline_disclaimer: `du lundi au vendredi de 9h30 à 17h30`,
      service_name: `MesBonsPros`,
      esca_certification: `Catégorie Services à l’habitat - Étude BVA Group - Viséo CI - mai à juillet 2018 - Plus d’infos sur <a href='http://www.escda.fr' target='_blank'>escda.fr</a>.`,
      who_we_are_link: `Qui sommes nous ?`,
      join_network_link: `Rejoindre notre réseau`,
      pro_app_download: `<strong>Professionels ?</strong> Téléchargez votre application mobile.`,
      app_link_ios: `https://ios.com`,
      app_link_android: `https://android.com`,
      links: {
        plumbing: `Dépannage plomberie`,
        electricity: `Dépannage électricité`,
        heating: `Dépannage chauffage`,
        air_conditionning: `Dépannage climatisation`,
        gas: `Dépannage gaz`,
        help: `Besoin d'aide`,
        who_we_are: `Qui sommes-nous ?`,
        terms_and_conditions: `Conditions générales de vente`,
        privacy: `Politique de données personnelles`,
        legal_notice: `Mentions légales`,
        our_rates: `Nos tarifs`,
      },
    },
    our_rates: {
      title: `Nos tarifs en dépannage plomberie, électricité et gaz`,
      desc: `Nos prestataires se déplacent à votre domicile 7j/7 de 8h à 22h. De ce fait, nos dépannages plomberie, électricité et gaz varient en fonction de l'heure à laquelle la prestation a lieu.`,
      no_data: `Chargement en cours...`,
      packages_depending_on_slot: `Nous proposons 3 forfaits selon le créneau demandé :`,
      package_slot_normal_rate: `En semaine de 8h à 18h : sans supplément`,
      package_slot_evening_saturday: `En soirée de 18h à 22h et le samedi de 8h à 22h : supplément soirée / samedi`,
      package_slot_sunday: `Le dimanche de 8h à 22h : supplément dimanche`,
      whats_included: `Le montant des prestations inclut le déplacement, la main-d'oeuvre, les fournitures. TVA à 10% sauf mention spéciale.`,
      price_vat_displayed: `Les tarifs sont présentés avec une TVA à taux réduit de 10% applicable en cas de travaux [...] Dans le cas contraire le taux TVA applicable sera revu au taux normal.`,
      table_headers: {
        job: `Prestation`,
        base_price: `Prix de base`,
        evening_saturday_price: `Prix soir & samedi`,
        sunday_price: `Prix dimanche & jours fériés`,
        duration: `Durée`,
        spare_parts: `Fournitures`,
      },
    },
    reinsurance: {
      number_one: `Numéro 1 en France <sup>*</sup>`,
      no_surprise: `Devis gratuit sans surprise`,
      customer_service: `Service client à votre écoute`,
      traders_network: `Des pros à votre service`,
      customer_satisfaction: `97% de taux de satisfaction <sup>**</sup>`,
      number_of_interventions:
        '<sup>*</sup> HomeServe France réalise une intervention toutes les 3 minutes au domicile de ses clients.<br><sup>**</sup> Selon l’enquête de satisfaction réalisée pour le compte de HomeServe, auprès de 31000 clients, après une intervention à leur domicile, entre avril 2019 et mars 2020, par le cabinet d’études indépendant Market Audit.',
    },
    breadcrumb: {
      to_home: `Accueil du site`,
    },
    homepage: {
      page_name: `Page d'accueil`,
      homeserve_block: {
        block_simple: `Simple, rapide, serein`,
        block_simple_desc: `En quelques clics, obtenez votre devis détaillé et complet en ligne. Suite à votre commande, un professionnel du réseau HomeServe vous contacte, afin d’affiner avec vous le diagnostic, et confirmer le rendez-vous.`,
        block_pro: `Réactifs, experts, fiables`,
        block_pro_desc: `Accédez aux meilleurs professionnels avec le groupe HomeServe, expert depuis plus de 20 ans dans la gestion de son réseau de 4000 professionnels. Notre objectif commun: vous garantir une prestation de qualité.`,
      },
      homeserve_expert: {
        title: `Simplifiez vos dépannages et petits travaux`,
        block_surprise: {
          title: `Sans surprise`,
          desc: `Devis gratuit et prix communiqué à l’avance`,
        },
        block_trust: {
          title: 'En toute confiance',
          desc: 'Paiement à la fin du chantier et réparation par nos Pros',
        },
        block_proximity: {
          title: 'Proche de chez vous',
          desc: 'Le Bon Pro en moyenne à - 30 km de chez vous',
        },
        block_quick: {
          title: 'Service client expert',
          desc: 'En France et à vos côtés, 7j/7 de 7h à 21h',
        },
        more_detail:
          '* Catégorie Services à l’habitat - Étude BVA - Viséo CI - Plus d’infos sur <a href="https://escda.fr.">escda.fr</a>.',
      },
    },
    product_page: {
      page_name: 'Page produits',
      included_in_job: `Inclus dans la prestation`,
      excluded_in_job: `Non inclus dans la prestation`,
      excluded_in_job_details: `Pour réaliser des travaux non inclus dans cette prestation, contactez-nous directement ou notre prestataire afin d'obtenir un devis complémentaire.`,
      advices: `Nos conseils`,
      linked_jobs_title: `Nos clients ont aussi consulté`,
      quotation_title: `Votre devis provisoire`,
      slot: `Créneau :`,
      vat_included: `TTC`,
      spare_parts_included: `Pièces et fournitures`,
      callout_included: `Frais de déplacement`,
      workforce_included: `Jusqu'à {duration} de main d'œuvre`,
      additionnal_fees: `Supplément horaire`,
      moreDetails: 'En savoir plus',
      alma: 'Payez en 3 ou 4 fois sans frais',
      condition_vat: `* Sous réserve d'éligibilité au taux de TVA réduit de {vat_rate} applicable au logement d'habitation achevé depuis plus de deux ans.`,
      information: `Grâce à notre aide au diagnostic, le devis reste le même dans la plupart des cas. Et pour les situations plus complexes, un nouveau devis est proposé et notre pro attend votre accord avant de réparer.`,
    },
    job_schedule: {
      schedule_title: `Précisez votre problème et choisissez le créneau d'intervention:`,
      schedule_comment_label: `Précisions sur votre dépannage`,
      schedule_comment_placeholder: `Tout ce qui pourrait être utile`,
      attach_photo: `Ajouter des photos, schémas ou vos plus beaux dessins pour nous aider à comprendre le problème`,
      attach_photo_choose_file: `Choisissez un fichier ou cliquez-déposez le ici`,
      place_order_cta: `Je valide`,
      slot: `Créneau`,
      delete: `Supprimer`,
      choose_job_slot: `Veuillez choisir un créneau d'intervention`,
      breadcrumb_item: `Prise de rendez-vous`,
      add_a_picture: `Ajoutez une photo`,
      request_callback: `Si aucun créneau ne vous convient, contactez-nous`,
    },
    personnal_information: {
      confirm_button_label: 'Valider mes informations',
      continue: 'Continuer',
      set_password_text: 'Gagnez du temps pour la prochaine commande et inscrivez-vous dès maintenant :',
      password: 'Mot de passe',
      save: 'Enregister',
      your_password_must_include: 'Votre mot de passe doit contenir au moins :',
      eight_characters: '8 caractères',
      one_capital_letter: 'Une majuscule',
      one_number: 'Un chiffre',
      one_lowercase_letter: 'Une minuscule',
      step_one: `1 - Mes informations`,
      step_two: `2 - Ma commande `,
      step_three: `3 - Ma confirmation`,
      end: {
        title: `Nous avons bien pris en compte votre demande d'intervention. Votre client recevra sous peu un email l'invitant à finaliser sa commande.`,
        btn_home: `Retourner à l'accueil`,
      },
      reconnaissance: {
        i_forgot_my_password: `Mot de passe oublié ?`,
        this_email_is_already_present_in_our_database: `Nous avons trouvé un compte avec cette adresse email. Pour continuer veuillez saisir votre mot de passe.`,
        reset_password_link_text: ` Si vous l'avez oublié, vous pouvez le réinitialiser en cliquant ici`,
        to_continue_please_log_in: `Pour continuer, merci de vous connecter`,
        log_in: `Se connecter`,
        password_placeholder: `Votre mot de passe`,
        reset_password_email_sent:
          'Nous vous avons envoyé un email à cette adresse pour réinitialiser votre mot de passe (pensez à vérifier votre dossier spam)',
        error_email_not_present_in_database: `Désolé, cette adresse email n'existe pas dans notre base de données`,
        error_login: 'Mot de passe invalide',
      },
      information: {
        confirmation: 'Confirmation',
        quotation: 'Devis',
        title: `Renseignez vos informations personnelles`,
        job_address: `Adresse de l'intervention :`,
        invoice_address_different: `Cochez cette case si vous avez une adresse de facturation différente`,
        invoice_address_different_link: `Si votre adresse de facturation est différente de votre adresse d'intervention <span>cliquez-ici</span>`,
        invoice_address: `Adresse de facturation :`,
        email_label: `Adresse email`,
        email_hint: `Afin de vous envoyer les informations relatives à votre dépannage`,
        email_invalid: `Le champ email doit être une adresse e-mail valide`,
        email_already_taken: `Cet email est déjà utilisé`,
        field_min_length: `XXXLe champ xxx requiert xxx caractères minimum`,
        field_required: `XXXLe champ xxx est obligatoire`,
        housing: {
          field_name: 'Âge du logement',
          label: `En validant, j'atteste que mon logement, achevé depuis plus de 2 ans, est utilisé à des fins d'habitation. Si ce n'est pas le cas, je coche la case `,
          more_detail: `(en savoir +)`,
          tooltip: `Le taux de TVA applicable est de 20 % pour les logements de moins de 2 ans ou utilisés à des fins professionnelles.`,
        },
        optin: {
          phone_snailmail: `Des offres et avantages exclusifs négociés spécialement pour vous pourront également vous être envoyés de la part de HomeServe et de ses partenaires par courrier et téléphone. Si vous ne le souhaitez pas, cochez cette case.`,
          sms_email: `Des offres relatives à des produits analogues et des avantages exclusifs de l'univers maison pourront vous être envoyés de la part de HomeServe par email & SMS. Si vous ne le souhaitez pas, cochez cette case.`,
        },
        cta_validate_information: `Valider mes informations`,
        form_error: `Veuillez corriger les erreurs de formulaires afin de passer à l'étape suivante.`,
        submit_error: `Une erreur est survenue, veuillez vérifier les informations que vous avez renseignées.`,
        error: {
          errorCreatingOrder: `La commande n'a pas pu être créée.`,
          badEmailFormat: `Votre adresse e-mail n’a pas pu être validée. Veuillez la vérifier ou en utiliser une autre afin de finaliser votre commande.`,
        },
      },
      contact: {
        title: `Civilité`,
        title_choices: {
          mr: `M.`,
          mrs: `Mme`,
        },
        title_placeholder: `Choisissez`,
        first_name: `Prénom`,
        last_name: `Nom`,
        address1: `Adresse de l’intervention`,
        address2: `Complément d'adresse (optionnel)`,
        address2_placeholder: `digicode, interphone, bâtiment`,
        edit_location_1: `Modifier les `,
        edit_location_2: `informations de localisation`,
        phone_placeholder: `Pour que le prestataire puisse confirmer le diagnostic et le RDV`,
        phone: `Téléphone`,
        phone_mandatory: `Le téléphone est obligatoire`,
        phone_not_valid: `Le numéro de téléphone n'est pas valide`,
        post_code: `Code postal`,
        country: `Pays`,
        street: `Rue`,
        streetNo: `Numéro`,
        manualInputRequired: `L'adresse que vous avez entrée est introuvable. Merci de rentrer les informations manuellement ci-dessous.`,
      },
      legal_warning: `Les informations recueillies permettent à HomeServe de réaliser la commande et d’effectuer des opérations relatives à la gestion de la relation client, notamment pour vous adresser par email ou téléphone des relances panier, enquêtes de satisfaction ainsi que les conseils et actus HomeServe pour prendre soin de votre maison. Vous bénéficiez d'un droit d'accès, de rectification, de limitation, d'effacement et d'opposition à l'utilisation de vos données personnelles. Pour plus d'informations, consultez notre <a href="{url}" title="Politique de données personnelles">politique de données personnelles</a>. Vous pouvez vous opposer aux démarchages téléphoniques par les entreprises dont vous n'êtes pas client, en vous inscrivant auprès de Bloctel (ww.bloctel.gouv.fr), une liste gratuite d'opposition aux appels commerciaux.<br/><br/>Vous pouvez à tout moment changer vos préférences de contact en appelant le Service Client.`,
      waiting_message: {
        base: 'Enregistrement en cours,',
        short: 'nous y sommes presque :)',
        long: 'plus que quelques secondes...',
      },
    },
    payment_form: {
      card_number: `Numéro de la carte`,
      expiry_month: `Mois`,
      expiry_year: `Année`,
      security_code: `Cryptogramme de sécurité (3 chiffres au dos de votre carte)`,
    },
    order_success: {
      title: `Merci pour votre commande !`,
      confirmation_email: `Surveillez votre boîte mail, vous allez recevoir tous les détails de votre intervention.`,
      next_steps: `Quelles sont les prochaines étapes ?`,
      step_1: `Vous allez recevoir un <strong>SMS</strong>&nbsp;avec les coordonnées du professionnel`,
      step_2: `Le bon Pro vous appelle pour confirmer le diagnostic.`,
      step_3: `Vous validez avec lui la date et l’heure du rendez-vous. `,
      step_4: `Une fois l’intervention terminée, votre carte bancaire sera débitée dans les 7 jours suivants l’intervention. <sup>*</sup>`,
      step_4_no_imprint: `Vous payez en ligne après l'intervention. <sup>*</sup>`,
      order_tracking: `Retrouvez le suivi de votre intervention en cliquant ci-dessous :`,
      cta_track_order: `Suivre mon intervention`,
      detail_payment: `* Pour bénéficier du paiement en plusieurs fois, rendez-vous dans votre espace de suivi à l’issue de votre intervention pour effectuer les démarches nécessaires.`,
      detail_photo_1: `Pensez aussi à ajouter une photo pour notre Pro dans votre`,
      detail_photo_2: `Espace de suivi.`,
    },
    tracking: {
      recap: {
        discount_code: 'Code promo',
        title: 'Récapitulatif de votre commande',
        disconnect: 'Suivre un autre dossier',
        appointment_date: `Date de l'intervention`,
        cancel_btn: 'Annuler la commande',
        cancel_confirmation: `Souhaitez-vous vraiment annuler votre commande ?`,
        cancel_reason: `Veillez préciser la raison de l'annulation`,
        cancel_reason_other_label: `Merci de nous indiquer le motif d'annulation de la commande`,
        cancel_confirm: `Annuler ma commande`,
        cancel_cancel: `Retour`,
        contact: `Informations de contact :`,
        email: 'Email',
        phone: `Téléphone`,
        total_price: 'Prix total',
        trader: 'Votre professionnel',
        tracking_number: 'Numéro de dossier',
      },
      title: `Suivi d'intervention`,
      intro: `Bonjour {title} {lastname}, voici votre suivi d'intervention`,
      quotation: 'devis',
      invoice: 'facture',
      login: {
        title: `Connectez-vous à votre espace de suivi de commande`,
        file_reference: `numéro de dossier`,
        last_name: `nom de famille`,
        cta_login: `Accéder à mon suivi`,
        login_invalid_error: `Nous ne reconnaissons pas ce dossier. Retrouvez votre numéro de dossier facilement dans votre email de confirmation de commande.`,
        login_connection_error: `Impossible de se connecter pour le moment. Veuillez réessayer plus tard.`,
      },
      contact: {
        title: `Des questions ?`,
        faq_link: `Consultez notre FAQ`,
        contact_us_phone: `ou contactez-nous au :`,
        contact_fees_phone: `(service gratuit + coût de l'appel)`,
        contact_email: `ou par email à :`,
        contact_email_address: `client@homeserve-depannage.fr`,
      },
      product_display: {
        tracking_number: `Numéro de dossier`,
        job_address: `Adresse d'intervention`,
        job_date: `Date : `,
        total_cost: `Prix total : `,
      },

      job_done: {
        title: `Intervention terminée`,
        desc: `Votre intervention est maintenant terminée.`,
      },
      job_in_progress: {
        title: `Intervention en cours`,
        desc: `Votre intervention est en cours par notre professionnel.`,
      },
      job_planned: {
        title: `Votre intervention est planifiée`,
        trader: `Votre professionnel`,
        contact: `Informations de contact :`,
        email: 'Email',
        phone: `Téléphone`,
        planned_date: `Date d'intervention prévue`,
      },
      looking_trader: {
        title: `Nous recherchons un professionnel`,
        desc: `Nous recherchons le professionnel le mieux qualifié pour répondre à votre besoin dans votre secteur`,
      },
      trader_found: {
        title: `Un professionnel a été trouvé`,
        desc: `Notre professionnel va prendre contact avec vous afin de confirmer les modalités de l'intervention`,
      },
      new_quote: {
        title: `Devis actualisé`,
        desc: `Le prix de votre devis a été actualisé.`,
        cta_download_quote: `Télécharger mon devis`,
      },
      quote_updated: {
        title: `Devis à jourXXXX`,
        desc: ``,
      },
      new_quote_action_needed: {
        accept_quotation: `Accepter le devis`,
        download_quotation: `Télécharger le devis actualisé`,
        refuse_quotation: `Refuser le devis`,
        refuse_quotation_cancel: `Retour`,
        refuse_quotation_confirm: 'Confirmer le refus',
        refuse_quotation_confirmation: `Votre devis ne sera pas validé et votre intervention annulée.</br>Confirmez vous le refus du devis ?`,
        refuse_quotation_confirmation_title: `Votre intervention`,
        title: `Devis actualisé`,
      },

      new_quote_accepted: {
        title: `Nouveau devis accepté`,
        desc: `Votre acceptation a été traitée avec succès.`,
      },
      new_quote_refused: {
        title: `Nouveau devis refusé`,
        desc: `Vous avez refusé le nouveau devis.`,
      },
      no_trader: {
        title: `Nous n'avons pas pu trouver de professionnel pour votre intervention`,
        desc: `Nous sommes désolés, malgré tous nos efforts nous n'avons pas trouvé de professionnel disponible à proximité de chez vous. Vous ne serez pas débité.`,
      },
      order_canceled: {
        title: `Votre commande est annulée`,
        desc: `Vous avez choisi d'annuler votre commande. Votre intervention a été annulée sans frais.`,
        title_not_related_homeserve: 'Votre commande est annulée',
        desc_not_related_homeserve: `Votre intervention a été annulée sans frais.`,
      },
      order_processing_payment: {
        title: `Paiement de la commande`,
        desc: `Suite à la clôture de l'intervention vous allez être débité du montant de {price} TTC`,
        special_offer: {
          title: 'Gagnez en sérénité, ne soyez plus pris de court !',
          content:
            'L’Assistance HomeServe vous permet d’être dépanné sans avoir à payer votre intervention (selon le contrat souscrit).',
          subcard: {
            title: '39€ remboursés sur votre dépannage *',
            content:
              'Jusqu’au {specialOfferDate}, HomeServe vous offre 39€ pour toute souscription à un contrat d’Assistance.',
            phone_number: 'Appelez le 01 70 95 26 10 pour plus d’infos.',
          },
          additional_information:
            '* Valable sur une sélection de contrats d’Assistance.<br>Remboursement de 39€ sous 2 mois sur le compte bancaire qui aura été utilisé pour l’achat du contrat d’Assistance.<br>Offre Valable pour tout contrat actif, après une période de 28 jours.<br>Contrat souscrit par la personne ayant été facturée de l’intervention de dépannage.',
        },
      },
      order_job_done: {
        title: `Votre intervention est terminée`,
        desc: `Votre intervention est maintenant terminée. Vous pouvez télécharger votre facture en cliquant sur le bouton ci-dessous.`,
        cta_download_invoice: `Télécharger ma facture`,
      },
      order_done_paid: {
        title: `Paiement Validé`,
        desc: `Votre paiement a été validé. Nous vous remercions de votre confiance.`,
      },
      trader_start_moving: {
        title: `Votre professionnel est en route`,
        desc: `Votre professionnel est en route pour se rendre sur le lieu de l'intervention.`,
      },
      new_order: {
        title: `Commande acceptée`,
        cancel_btn: `Annuler ma commande`,
        cancel_confirmation: `Souhaitez-vous vraiment annuler votre commande ?`,
        cancel_reason: `Veillez préciser la raison de l'annulation`,
        cancel_reason_diy: `J'ai trouvé une autre solution (réparé tout seul, autre prestataire, problème résolu,...)`,
        cancel_reason_trader: `Le prestataire ne s'est pas présenté à l'heure convenue`,
        cancel_reason_other: `Autre motif (veuillez préciser)`,
        cancel_reason_other_label: `Merci de nous indiquer le motif d'annulation de la commande`,
        cancel_confirm: `Annuler ma commande`,
        cancel_cancel: `Retour`,
        download_quotation: `Télécharger le devis`,
      },
      review_trader: {
        title: `Evaluez votre professionnel`,
        desc: `Votre intervention est maintenant terminée et nous espérons qu'elle vous a apporté pleine satisfaction. Nous vous invitons à prendre une poignée de secondes pour répondre à quelques questions. Cela nous aide à vous offrir une expérience de qualité. Merci !`,
        cta_rate_trader: `Répondre à quelques questions`,
      },
      trader_has_canceled: {
        title: `Votre professionnel a annulé l'intervention`,
        desc: `Un autre professionnel va vous contacter pour convenir d'un nouveau rendez-vous.`,
        desc_no_show: `Vous n'étiez pas présent à l'heure convenue du rendez-vous.`,
        title_not_related_homeserve: `Votre intervention n'est pas du ressort de MesBonsPros`,
        desc_not_related_homeserve: `Nous avons le regret de vous informer que d'après le professionnel, votre problème ne rentre pas dans le catalogue de prestations du service MesBonsPros.
        Nous allons procéder à une annulation sans frais de votre commande, aucun frais d'annulation ne vous sera facturé.`,
        title_canceled: `Votre intervention est annulée`,
        desc_canceled: `Votre intervention a été annulée`,
      },
      order_canceled_fees: {
        title: `Paiement des frais d'annulation`,
        desc: `Votre intervention a été annulée, en accord avec nos CGV, nous allons procéder au prélèvement d'un montant forfaitaire pour couvrir le déplacement de notre prestataire.`,
        amount_of_cancellation_fees: `Montant des frais d'annulation`,
      },
      order_waiting_payment: {
        title: 'Paiement de votre intervention',
        desc: `Par défaut, <b>votre carte bancaire sera débitée du montant de votre facture d'ici 7 jours.</b> Si vous souhaitez payer en 3x 4x sans frais, cliquez sur le bouton ci-dessous:`,
        desc_no_imprint: `Veuillez saisir vos informations bancaires afin que nous puissions procéder au paiement en ligne de votre intervention. Si vous souhaitez payer en 3x ou 4x sans frais, cliquez sur le bouton ci-dessous.`,
        validation_success: `Merci, votre paiement a bien été validé.`,
        special_offer_odtp:
          'Une fois votre intervention réglée, découvrez comment <span class="red--text bold">bénéficier d\'un remboursement de {amount}€</span> sur celle-ci !',
        legal_notice: `Ces informations sont nécessaires à HomeServe et au prestataire de paiement électronique pour le paiement de votre commande.`,
        legal_notice_alma: `En cliquant sur le bouton, vous acceptez d’être redirigé vers le site de notre partenaire Alma afin d’effectuer une demande de paiement en plusieurs fois.`,
        legal_notice_cgu: ` Pour plus d’informations sur vos données et sur vos droits, consultez notre <a href="{url}" title="Politique de données personnelles">politique de données personnelles</a>.`,
        waiting_alma: `Votre demande de paiement en plusieurs fois auprès de Alma est en cours de traitement. Veuillez patienter quelques instants et rafraîchir la page en cliquant <a href="javascript:window.location.href=window.location.href">ici</a>.`,
      },
      order_payment_failed: {
        title: `Oups, votre paiement n'a pas pu aboutir`,
        desc: `Le paiement de votre intervention est en echec, veuillez re-saisir vos coordonnées bancaires ci-dessous. Si vous rencontrez des difficultés, contactez nous par téléphone.`,
        validation_success: `Merci, votre paiement a bien été validé.`,
        legal_notice: `Ces informations sont nécessaires à HomeServe et au prestataire de paiement électronique pour le paiement de votre commande. Pour plus d’informations sur vos données et sur vos droits, consultez notre <a href="/politique-de-confidentialite">politique de données personnelles</a>.`,
      },
      pictures_gallery: {
        customer_photos: `Vos photos`,
        trader_photos: `Photos de l'intervention`,
        before_work_photo: `avant travaux`,
        after_work_photo: `après travaux`,
        signature_photo: `signature`,
      },
      order_waiting_alma: {
        title: 'Paiement de votre intervention',
        desc: `Votre demande de paiement en plusieurs fois auprès de Alma est en cours de traitement. Veuillez patienter quelques instants et rafraîchir la page en cliquant <a href="javascript:window.location.href=window.location.href">ici</a>.`,
      },
    },
    who_are_we_page: {
      page_name: 'Page qui sommes-nous ?',
    },
    fix_appointment_page: {
      page_name: 'Page prise de rendez-vous',
    },
    tunnel_page: {
      page_name: 'Page tunnel de commande',
      info_section: {
        page_name: 'Page tunnel de commande - Informations',
        google_tag_manager_category: 'Tunnel informations',
        google_tag_manager_error_action: 'Erreur',
        google_tag_manager_error_phone: 'Téléphone',
        blacklisted: 'Votre demande ne peut aboutir. Merci de nous contacter par téléphone.',
      },
      summary_section: {
        page_name: 'Page tunnel de commande - Récapitulatif',
      },
      confirmation_section: {
        page_name: 'Page tunnel de commande - Confirmation',
      },
    },
    follow_order_login_page: {
      page_name: 'Page de connexion suivi de commande',
    },
    terms_and_conditions_page: {
      page_name: 'Conditions générales de vente',
    },
    legal_notices_page: {
      page_name: 'Mentions légales',
    },
    faq_page: {
      page_name: 'FAQ',
    },
    our_rates_page: {
      page_name: 'Nos tarifs',
    },

    // useful for GTM
    legal_domain: 'Juridique',
    transversal_domain: 'Transverse',
    your_preferences_will_be_communicated_to_the_convenience_store_who_will_call_you_back_to_schedule_the_appointment:
      'Vos préférences seront communiquées au dépanneur qui vous rappelera afin de fixer le rendez-vous',
    select_your_appointment_preferences: 'Séléctionner vos préférences de rendez-vous',
    follow_order: {
      page_name: 'Suivi - {step}',
      google_tag_manager_domain: 'Suivi de commande',
      cant_connect_please_check_your_informations: 'Impossible de se connecter, veuillez vérifier vos informations.',
      cant_connect_please_try_again_later: 'Impossible de se connecter, veuillez réessayer ultérieurement',
      looking_trader_title: 'Nous recherchons un prestataire',
      looking_trader_text: 'Nous recherchons un prestataire correspondant à votre problème proche de chez vous',
      order_placed: 'Commande passée',
      order_reference: 'N° de commande',
      deployment_reference: 'N° intervention',
      deployment_address: `Adresse d'intervention`,
      included_spare_parts: 'Pièces et fournitures',
      callout_price: 'Frais de déplacement',
      job_duration: `Jusqu'à {duration} de main d'oeuvre`,
      estimate_total: 'Total du devis',
      cancel_my_order: 'annuler ma commande',
      accept_the_quotation: 'accepter le devis',
      refuse_the_quotation: 'refuser le devis',
      download_updated_quotation: 'Télécharger le devis mis à jour',
      any_questions: 'Des questions ?',
      consult_our_faq: 'consultez notre FAQ',
      or_contact_us_at: 'ou contactez nous au',
      free_service_plus_cost_of_the_call: `service gratuit + coût de l'appel`,
      or_by_email_at: 'ou par email à',
      do_you_really_want_to_cancel_order: 'Voulez-vous vraiment annuler votre commande ?',
      do_you_really_want_to_refuse_quotation: 'Voulez-vous vraiment refuser le devis ?',
      yes: 'oui',
      no: 'non',
      am: 'le matin',
      am_short: 'Matin',
      pm: `l'après-midi`,
      pm_short: 'Après-midi',
      evening: 'en soirée',
      evening_short: 'Soirée',
      order_cancelled: 'Commande annulée',
      no_trader_found_title: `Nous avons le regret de vous annoncer que nous n'avons trouvé aucun prestataire disponible à proximité de chez vous pour prendre en charge votre problème`,
      trader_found: 'Un prestataire a été trouvé',
      trader_found_long: `Notre prestataire va prendre contact avec vous afin de confirmer les modalités de l'intervention`,
      job_planned: 'Votre intervention est planifiée',
      trader: 'prestataire',
      contact: 'contact',
      job_in_progress: 'Intervention en cours',
      your_job_is_in_progress: 'Votre intervention est en cours',
      order_cancelled_long: `Vous avez choisi d'annuler votre commande. Votre intervention a été annulée sans frais`,
      quote_updated: 'Devis actualisé',
      extra_charge: 'Supplément si majoration tarifaire',
      quotation_accepted: 'Nouveau devis accepté',
      download_my_invoice: 'Télécharger ma facture',
      order_payment: 'Intervention cloturée',
      rate_your_trader: 'Évaluer mon professionnel',
      job_done: 'Intervention terminée',
      trader_start_moving: 'Prestataire en route',
      new_quote_refused: 'Nouveau devis refusé',
      your_trader_updated_the_quote_less_money:
        'Votre professionnel a  modifié le créneau horaire entraînant une baisse du montant du devis',
      your_trader_updated_the_quote: 'Votre professionnel a validé le créneau horaire',
      cancel_reason: `Raison d'annulation`,
      your_trader_has_canceled: `Votre professionnel a annulé l'intervention`,
      your_trader_has_canceled_the_job_planned_on: `Votre professionnel a annulé l'intervention prévue le `,
      cause: 'Cause',
      another_trader_will_take_the_job: 'Un autre professionnel va vous contacter pour fixer un nouveau rendez-vous',
      order_review: `Suivi d'intervention`,
      hello: 'Bonjour',
      here_is_your_order_review: `Voici votre suivi d'intervention`,
      validate: 'Valider',
      download_my_quote: 'Télécharger mon devis',
      order_cancelled_no_show: `Votre intervention a été annulée, en accord avec nos CGV, nous allons procéder au prélèvement d'un montant forfaitaire pour couvrir le déplacement de notre prestataire`,
      cancelation_fees_payment: `Paiement des frais d'annulation`,
      you_were_absent: `Vous n'étiez pas là le jour de l'intervention`,
      add_pictures: `Ajoutez des photos`,
      upload_picture_title: `👋  Les images parlent parfois plus que les mots, aidez notre Pro avec une photo.`,
      upload_picture_description: `Jusqu’à 3 photos, formats pris en charge : jpg, png. Le contenu que vous téléchargez est sous votre responsabilité`,
      upload_valid: `Je valide`,
      upload_success: `Merci, les photos ont bien été ajoutées à votre dossier`,
    },
    outdatedTimeSlotModal: {
      title: `Créneau indisponible.`,
      text: `Le créneau choisi n'est plus disponible, merci d'en sélectionner un nouveau.`,
      confirm: 'Choisir un nouveau créneau',
    },
    bank: {
      name_alma: 'Paiement en 3x ou 4x SANS FRAIS',
      name_cb: 'Pré-autorisation bancaire',
      refused_message_token: 'Echec de la pré-autorisation bancaire. Nous vous conseillons de contacter votre banque.',
      error_message_token: 'Une erreur est survenue. Veuillez réessayer ou contactez-nous par téléphone.',
      success_message_token: 'Pré-autorisation bancaire validée.',
      follow_alma: 'Poursuivre vers Alma',
    },
    modal: {
      error_3ds: {
        title: `Echec de l'autorisation de paiement`,
        body: `Veuillez vérifier les détails de votre carte bancaire et réessayer.<br>
      Si ce message persiste notre service client est à votre disposition au <a class="no-decoration" href="{supportPhoneNumberLink}">{supportPhoneNumber}</a> ou par email : <a class="no-decoration"  href="mailto:client@homeserve-depannage.fr">client@homeserve-depannage.fr</a>.`,
      },
      error_new_quote: {
        title: `Oops`,
        body: `Nous n'arrivons pas à mettre à jour votre devis 😕.<br> Pas de panique, appelez-nous au <a class="no-decoration" href="{supportPhoneNumberLink}">{supportPhoneNumber}</a> pour le faire avec un de nos conseillers.`,
      },
      close: 'Fermer',
    },
  },
};
